const Taxi = (state) => state.Taxi
const Voucher = (state) => state.Voucher
const taxiCompanies = (state) => state.taxiCompanies
const TaxiInfo = (state) => state.taxiInfo
const dataBank = (state) => state.dataBank
const TaxiPrice = (state) => state.taxiPrice
const IsGetSuccessVoucher = (state) => state.isGetSuccessVoucher

export default {
  Taxi,
  Voucher,
  taxiCompanies,
  TaxiInfo,
  dataBank,
  TaxiPrice,
  IsGetSuccessVoucher
}
